define('views/blocks/OrderLineView',['underscore', 'backbone',

], function (_, Backbone) {

    var OrderLineView = Backbone.View.extend({
        events: {
            'click .btn-edit':'editMode',
            'click .btn-submit':'onSubmit'
        },

        editMode: function(){
            var view = this;
            view.$el.addClass('editable');
            view.$('.input-title').focus();
        },
        onSubmit: function(){
            var view = this,
                newVal = view.$('.input-title').val();
            view.$el.removeClass('editable');
            view.$('.title').text(newVal);
        }
    });

    return OrderLineView;
});
